import React from 'react';
import { useChatWidgetContext } from 'features/nekst-widgets';

const stubConversations = [
  { id: 1, title: 'Transaction status update', date: 'Today' },
  { id: 2, title: 'Upcoming deadlines review', date: 'Today' },
  { id: 3, title: 'Contact lookup for 123 Main St', date: 'Yesterday' },
  { id: 4, title: 'Team activity summary', date: 'Yesterday' },
  { id: 5, title: 'Closing checklist questions', date: 'Last 7 days' },
  { id: 6, title: 'Document requirements', date: 'Last 7 days' },
];

function ConversationItem(props: {
  title: string;
  active: boolean;
  onClick: () => void;
}) {
  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      type="button"
      onClick={props.onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        padding: '10px 12px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: props.active ? '#e5e7eb' : hovered ? '#f3f4f6' : 'transparent',
        cursor: 'pointer',
        fontSize: '14px',
        lineHeight: '1.4',
        color: '#1f2937',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {props.title}
    </button>
  );
}

function DateGroup(props: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: '8px' }}>
      <div style={{
        fontSize: '12px',
        fontWeight: 600,
        color: '#6b7280',
        padding: '8px 12px 4px',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
      }}>
        {props.label}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {props.children}
      </div>
    </div>
  );
}

export default function ConversationsSidebar() {
  const { resetConversation, currentConversationId } = useChatWidgetContext();

  const grouped = stubConversations.reduce<Record<string, typeof stubConversations>>((acc, conv) => {
    if (!acc[conv.date]) {
      acc[conv.date] = [];
    }
    acc[conv.date].push(conv);
    return acc;
  }, {});

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ padding: '12px' }}>
        <button
          type="button"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
            padding: '10px 12px',
            backgroundColor: 'transparent',
            color: '#1f2937',
            borderRadius: '8px',
            fontWeight: 500,
            fontSize: '14px',
            border: '1px solid #e5e7eb',
            cursor: 'pointer',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
          }}
          onClick={resetConversation}
          data-testid="new-chat-button"
        >
          <span style={{ fontSize: '16px', lineHeight: 1 }}>+</span>
          New Thread
        </button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '0 12px' }}>
        {Object.entries(grouped).map(([date, conversations]) => (
          <DateGroup key={date} label={date}>
            {conversations.map((conv) => (
              <ConversationItem
                key={conv.id}
                title={conv.title}
                active={currentConversationId === conv.id}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onClick={() => {}}
              />
            ))}
          </DateGroup>
        ))}
      </div>
    </div>
  );
}
